import {CTABanner, Button, Image, Section, Text} from '@primer/react-brand'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import {Spacer} from './_shared'

export default function Cta() {
  return (
    <Section id="cta">
      <Spacer size="100px" />

      <Image
        src="/images/modules/site/home24/cta.webp"
        alt=""
        width="960"
        style={{display: 'block', marginInline: 'auto'}}
      />

      <Spacer size="48px" size1012="80px" />

      <CTABanner className="lp-Cta sh-CtaWithTrial" align="center" hasBackground={false} hasShadow={false}>
        <CTABanner.Heading as="h2">Millions of developers and businesses call GitHub home</CTABanner.Heading>

        <CTABanner.Description className="lp-Cta-description">
          Whether you’re scaling your development process or just learning how to code, GitHub is where you belong. Join
          the world’s most widely adopted AI-powered developer platform to build the technologies that redefine what’s
          possible.
        </CTABanner.Description>

        <CTABanner.ButtonGroup>
          <Button
            href="/signup?source=form-home-signup"
            hasArrow={false}
            {...getAnalyticsEvent({action: 'sign_up', tag: 'button', context: 'CTAs', location: 'bottom_cta_section'})}
          >
            Sign up
          </Button>

          <Button
            href="/features/copilot"
            hasArrow={false}
            {...getAnalyticsEvent({
              action: 'try_copilot',
              tag: 'button',
              context: 'CTAs',
              location: 'bottom_cta_section',
            })}
          >
            Try GitHub Copilot
            <Text className="sh-CtaWithTrial-label" size="100">
              30 days free
            </Text>
          </Button>
        </CTABanner.ButtonGroup>
      </CTABanner>
    </Section>
  )
}

try{ Cta.displayName ||= 'Cta' } catch {}